import React, { FC, useEffect, useRef, useState } from 'react'
import { useAtom } from 'jotai'
import { createUseStyles } from 'react-jss'
import { Member } from '../../../models/Member'
import { Note } from '../../../models/Note'
import { Overlay } from '../../ui/Sidebar'
import { DrawerHeaderMemberInfo } from '../FormElements/DrawerHeader'
import { AddNewNote } from './AddNewNote'
import { EditNote } from './EditNote'
import { getOwnMember, membersAtom } from '../../../api/members/members'
import { Button } from '../../ui/Button/Button'
import { CircleIcon2 } from '../../ui/Circle/Circle'
import { Archive, DeleteFill, EditFill } from '../../../assets/icons'
import { colors } from '../../../theme/palette'
// import { L } from '../../providers/Lokalise'

const useStyles = createUseStyles({
    actions: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'flex-end',
    },
})

type ViewStates = 'default' | 'create' | 'edit' | 'delete'

interface EditMemberNotesProps {
    note: Note
    onUpdated?: () => void
    setShowDelete: (note: Note) => void
}

const EditNoteFromPage: FC<EditMemberNotesProps> = ({
    note,
    onUpdated,
    setShowDelete,
}) => {
    const [notes] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [viewState, setViewState] = useState<ViewStates>('edit')
    const [members] = useAtom(membersAtom)
    const [member, _setMember] = useState<Member | undefined>(undefined)

    const classes = useStyles()

    const setMember = async (id: number): Promise<void> => {
        const response = await getOwnMember(String(id))

        _setMember(Member.build(response.data))
    }

    useEffect(() => {
        const findMember = (): void => {
            // init()
            const found = members.members.find(
                (m) => m.memberId === +note.referenceId
            )

            if (found && !member) {
                setMember(found.memberId)
            }
        }
        if (isOpen) {
            findMember()
        }
    }, [isOpen, member, members.members, note.referenceId])

    return (
        <>
            <div className={classes.actions}>
                <Button
                    type="action"
                    onClick={() => setShowDelete(note)}
                    style={{ marginLeft: '20px' }}
                >
                    <CircleIcon2 width="34px" backgroundColor={colors.red100}>
                        <DeleteFill width="20px" color={colors.red600} />
                    </CircleIcon2>
                </Button>
                <Button
                    type="action"
                    style={{ marginLeft: '20px' }}
                    onClick={() => {
                        setViewState('edit')
                        setIsOpen(true)
                    }}
                >
                    <CircleIcon2 width="34px">
                        <EditFill width="22px" color={colors.green500} />
                    </CircleIcon2>
                </Button>{' '}
            </div>

            <Overlay
                isShowing={isOpen}
                hide={() => {
                    setIsOpen(false)
                }}
            >
                <DrawerHeaderMemberInfo member={member} />

                {viewState === 'create' ? (
                    <AddNewNote
                        member={member}
                        type="member"
                        hasNotes={notes.length > 0}
                        onClickCancel={() => {
                            setViewState('default')
                            if (notes.length === 0) {
                                setIsOpen(false)
                            }
                        }}
                        onUpdated={() => {
                            setViewState('default')
                        }}
                    />
                ) : null}

                {viewState === 'edit' && note && isOpen ? (
                    <EditNote
                        note={note}
                        onCancel={() => {
                            setIsOpen(false)
                        }}
                        onUpdated={() => {
                            setIsOpen(false)
                            if (onUpdated) {
                                onUpdated()
                            }
                        }}
                    />
                ) : null}
            </Overlay>
        </>
    )
}

export { EditNoteFromPage }
